import React, {useContext} from 'react'
import { Row, Col } from 'react-bootstrap';
import styles from './tab-overview.module.scss';
import {SecurityContext} from "../../../../../context/security-context";
import {getCouponFrequencies, getCouponTypes, getSecurityForm} from "../../../../../helpr/listingFormData";
import {formatDate, toCurrency} from "../../../../../helpr/helper";

const OverviewTab = () => {
  //Get security information from context
  const { securityState } = useContext(SecurityContext);
  const renderFormValue = key => getSecurityForm().filter(t => t.value === key)[0].name;
  const renderCouponTypeValue = key => getCouponTypes().filter(t => t.value === key)[0].name;
  const renderCouponFreqValue = key => getCouponFrequencies().filter(t => t.value === key)[0].name;

  return (
    <div className={styles['overview']}>
      <Row>
        <Col lg={12}>
          <h1>ABOUT THE ISSUER</h1>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['info']}>
            <img alt={securityState.securityName} src={`${process.env.REACT_APP_ASSETS_URL}${securityState.iconUrlSrc}`} />
          </div>
        </Col>
        <Col lg={12}>
          <div className={styles['info']}>
            <label>{securityState.issuer}</label>
            <span><a href={`//${securityState.issueSiteUrl}`} target="_blank">Visit Issuer Website</a></span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <h1>ISSUE DETAILS</h1>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['info']}>
            <label>Denomination</label>
            <span>
              {`Shall be issued in ${renderFormValue(securityState.securityForm)} form in minimum denominations of
              ${securityState.currency} ${toCurrency(securityState.denomination.value.primary.minimum)} each and in multiples of 
              ${securityState.currency} ${toCurrency(securityState.denomination.value.primary.increments)} thereafter.`}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['info']}>
            <label>Interest Payment Date</label>
            <span>{renderCouponFreqValue(securityState.couponFrequency)}{securityState.interestPaymentDate ? `(${securityState.interestPaymentDate})` : ''}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['info']}>
            <label>Maturity Date</label>
            <span>{formatDate(securityState.maturityDate)}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['info']}>
            <label>Interest Rate</label>
            <span>{`${renderCouponTypeValue(securityState.couponType)} (${securityState.interestRate})`}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['info']}>
            <label>Offer Period</label>
            <span>{`${securityState.offerDate} to ${securityState.offerCloseDate}`}</span>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default OverviewTab;
